import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "SportsLayout" */ './SportsLayout'),
  modules: ['./SportsLayout'],
  loading: () => null
});

export default LoadableWidget;
